import React, { useEffect, useState } from 'react';
import {
  Box, Card, CardContent, Typography, Stack, TextField, Button, Switch,
  FormControlLabel, Alert, Chip, Divider, CircularProgress, MenuItem,
} from '@mui/material';
import { ShoppingCart, CheckCircle, PlayArrow, Save } from '@mui/icons-material';
import { api } from '../config/api';

const WooCommerce: React.FC = () => {
  const [cfg, setCfg] = useState<any>({ tool_catalogo: true, tool_pedidos: true });
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState<{ t: string; sev: any } | null>(null);
  const [verificando, setVerificando] = useState(false);
  const [prueba, setPrueba] = useState({ tipo: 'producto', criterio: '' });
  const [resultadoPrueba, setResultadoPrueba] = useState('');

  const cargar = () => {
    setLoading(true);
    api.get('/woocommerce').then((r) => { if (r.data.config) setCfg({ ...cfg, ...r.data.config }); }).finally(() => setLoading(false));
  };
  useEffect(cargar, []); // eslint-disable-line

  const guardar = async () => {
    setMsg(null);
    await api.put('/woocommerce', cfg);
    setMsg({ t: 'Configuración guardada', sev: 'success' });
    cargar();
  };

  const verificar = async () => {
    setVerificando(true); setMsg(null);
    try {
      const { data } = await api.post('/woocommerce/verificar');
      if (data.ok) setMsg({ t: `Conectado. ${data.productos} productos en la tienda.`, sev: 'success' });
      else setMsg({ t: `Error: ${data.error}`, sev: 'error' });
    } finally { setVerificando(false); }
  };

  const probar = async () => {
    setResultadoPrueba('Consultando...');
    const { data } = await api.post('/woocommerce/probar', prueba);
    setResultadoPrueba(data.resultado || 'Sin resultado');
  };

  if (loading) return <Box sx={{ textAlign: 'center', mt: 6 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <ShoppingCart sx={{ color: '#96588a' }} />
        <Typography variant="h4">WooCommerce</Typography>
      </Stack>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Conecta tu tienda WooCommerce. El agente podrá mostrar tu catálogo y responder el estado de los pedidos de tus clientes automáticamente.
      </Typography>

      {msg && <Alert severity={msg.sev} sx={{ mb: 2 }} onClose={() => setMsg(null)}>{msg.t}</Alert>}

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>Credenciales de la tienda</Typography>
          <Alert severity="info" sx={{ mb: 2 }}>
            En WordPress: WooCommerce → Ajustes → Avanzado → REST API → "Añadir clave". Permisos: Lectura. Copia la Consumer Key y Secret.
          </Alert>
          <Stack spacing={2}>
            <TextField label="URL de la tienda" fullWidth placeholder="https://mitienda.cl" value={cfg.store_url || ''} onChange={(e) => setCfg({ ...cfg, store_url: e.target.value })} />
            <TextField label="Consumer Key" fullWidth placeholder="ck_..." onChange={(e) => setCfg({ ...cfg, consumer_key: e.target.value })} helperText={cfg.tiene_credenciales ? 'Ya hay credenciales guardadas (escribe para cambiar)' : ''} />
            <TextField label="Consumer Secret" fullWidth type="password" placeholder="cs_..." onChange={(e) => setCfg({ ...cfg, consumer_secret: e.target.value })} />
            <Stack direction="row" spacing={2}>
              <FormControlLabel control={<Switch checked={!!cfg.tool_catalogo} onChange={(e) => setCfg({ ...cfg, tool_catalogo: e.target.checked })} />} label="Mostrar catálogo" />
              <FormControlLabel control={<Switch checked={!!cfg.tool_pedidos} onChange={(e) => setCfg({ ...cfg, tool_pedidos: e.target.checked })} />} label="Consultar pedidos" />
            </Stack>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" startIcon={<Save />} onClick={guardar}>Guardar</Button>
              <Button variant="outlined" onClick={verificar} disabled={verificando}>{verificando ? 'Verificando...' : 'Verificar conexión'}</Button>
            </Stack>
            {cfg.activo && <Chip icon={<CheckCircle />} color="success" label="Tienda conectada" />}
          </Stack>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>Probar</Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }}>
            <TextField select size="small" label="Tipo" value={prueba.tipo} onChange={(e) => setPrueba({ ...prueba, tipo: e.target.value })} sx={{ width: { xs: '100%', sm: 160 } }}>
              <MenuItem value="producto">Buscar producto</MenuItem>
              <MenuItem value="pedido">Estado de pedido</MenuItem>
            </TextField>
            <TextField size="small" fullWidth placeholder={prueba.tipo === 'producto' ? 'Ej: sofá' : 'Nº de pedido o email'} value={prueba.criterio} onChange={(e) => setPrueba({ ...prueba, criterio: e.target.value })} />
            <Button variant="outlined" startIcon={<PlayArrow />} onClick={probar}>Probar</Button>
          </Stack>
          {resultadoPrueba && <Paper sx={{ p: 2, bgcolor: '#f8fafc', whiteSpace: 'pre-wrap', fontSize: 14 }}>{resultadoPrueba}</Paper>}
        </CardContent>
      </Card>
    </Box>
  );
};

// pequeño Paper inline para evitar import extra arriba
const Paper: React.FC<{ sx?: any; children: React.ReactNode }> = ({ sx, children }) => (
  <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 2, ...sx }}>{children}</Box>
);

export default WooCommerce;
